module.exports = __webpack_public_path__ + "assets/img/success.47074806.svg";